import EditIcon from '@mui/icons-material/Edit';
import { Avatar, Grid, IconButton, TableCell, TableRow, Typography } from '@mui/material';
import { Theme } from '@mui/material/styles';
import * as React from 'react';
import { useHistory } from 'react-router-dom';
import { makeStyles } from 'tss-react/mui';
import { settingsRoutes } from '../../../routes';
import { UserInfo } from '../../../sic-lib/types/UserConfig';
import { getUserAvatarInitials } from '../../../sic-lib/utils/userHelpers';
import DisplayPhoneNumber from '../../Shared/DisplayPhoneNumber/DisplayPhoneNumber';

interface Props {
    user: UserInfo;
}

export default function UsersListItem({ user }: Props) {
    const { classes } = useStyles();
    const history = useHistory();

    const userInitials = React.useMemo(
        () => getUserAvatarInitials(user.firstName, user.lastName, user.userName),
        [user],
    );

    const handleClick = () => {
        history.push(settingsRoutes.setCreateEditUser(user.userName));
    };

    return (
        <TableRow>
            <TableCell>
                <Avatar sx={{ background: user.colour || 'grey' }}>{userInitials}</Avatar>
            </TableCell>
            <TableCell className={classes.userName}>
                <Grid container flexDirection="column">
                    <Grid item>{user.userName}</Grid>
                    <Grid item>
                        <Typography variant="caption">
                            {user.firstName} {user.lastName}
                        </Typography>
                    </Grid>
                </Grid>
            </TableCell>
            <TableCell>
                <DisplayPhoneNumber phoneNumber={user.phone} />
            </TableCell>
            <TableCell>{user.email}</TableCell>
            <TableCell className={classes.rightAlign}>
                <IconButton onClick={handleClick}>
                    <EditIcon />
                </IconButton>
            </TableCell>
        </TableRow>
    );
}

const useStyles = makeStyles()((theme: Theme) => ({
    userName: {
        fontWeight: 'bold',
    },
    rightAlign: {
        textAlign: 'right',
    },
}));
